import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import DefaultersType from "../components/DefaultersType";
import IndividualDefaulters from "../components/IndividualDefaulters";
import InstutionalDefaulters from "../components/InstutionalDefaulters";
import Breadcrumbs from "../../../../Components/Common/BreadCrumbs";
import CICServices from "../../../../services/COOPServices/CICServices";
import { useFormik } from "formik";
import toast from "react-hot-toast";
import CicValidation from "../../../../validation/CicValidation";

const AddDefaulters = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [activeArrowTab, setActiveArrowTab] = useState(4);
  const [passedArrowSteps, setPassedArrowSteps] = useState([1]);
  const [defaultersType, setDefaultersType] = useState("Individual");
  const [defaulter, setDefaulter] = useState();

  useEffect(() => {
    if (id) {
      fetchDefaulterData(id);
    }
  }, [id]);

  const fetchDefaulterData = async (id) => {
    try {
      const response = await CICServices.getById(id);
      setDefaulter(response);
      console.log("🚀 ~ response:", response);
      // formik.setFieldValue("name", response.name);
      // formik.setFieldValue("address", response.address);
      // formik.setFieldValue("cooperativeId", response.cooperativeId);
      // formik.setFieldValue("citizenshipNumber", response.citizenshipNumber);
      // formik.setFieldValue("citizenshipIssueDistrict", {
      //   label: response.citizenshipIssueDistrict,
      //   value: response.citizenshipIssueDistrict
      // });
      // formik.setFieldValue("fathersFullName", response.fathersFullName);
      // formik.setFieldValue("grandfatherFullName", response.grandfatherFullName);
      // formik.setFieldValue("registrationNumber", response.registrationNumber);
      // formik.setFieldValue("submissionNumber", response.submissionNumber);
      // formik.setFieldValue("submissionDate", response.submissionDate);
      // formik.setFieldValue("spouseFullName", response.spouseFullName);
      // formik.setFieldValue("loanAmount", response.loanAmount);
      // formik.setFieldValue("loanMaturityDate", response.loanMaturityDate.slice(0, 10)); // Ensure the date is in "YYYY-MM-DD" format

      // formik.setFieldValue("reportingBasis", response.reportingBasis);
      setDefaultersType(
        response.defaulterType === "Individual" ? "Individual" : "Institutional"
      );
      // console.log("cic response",response)
      setActiveArrowTab(5);
    } catch (error) {
      console.log("🚀 ~ async ~ error:", error);
    }
  };

  const toggleArrowTab = (tab) => {
    if (activeArrowTab !== tab) {
      var modifiedSteps = [...passedArrowSteps, tab];
      if (tab >= 4 && tab <= 7) {
        setActiveArrowTab(tab);
        setPassedArrowSteps(modifiedSteps);
      }
    }
  };

  const breadcrumbItems1 = [
    { title: "CIC", link: "/cic" },
    { title: "CIC Form" },
  ];

  useEffect(() => {
    if (defaultersType === "Individual") {
      formik.setFieldValue("defaulterType", "Individual");
    } else {
      formik.setFieldValue("defaulterType", "Institutional");
    }
  }, [defaultersType]);

  const coopid = localStorage.getItem(id)
    ? JSON.parse(localStorage.getItem(id))
    : "";

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: defaulter?.name ?? "",
      address: defaulter?.address ?? "",
      cooperativeId: coopid || "",
      submissionNumber: defaulter?.submissionNumber ?? "",
      loanAmount: defaulter?.loanAmount ?? "",
      loanMaturityDate: defaulter?.loanMaturityDate
        ? defaulter.loanMaturityDate.slice(0, 10)
        : "",
      reportingBasis: defaulter?.reportingBasis ?? "",
      defaulterType: defaulter?.defaulterType ?? "",
      citizenshipNumber: defaulter?.citizenshipNumber ?? "",
      citizenshipIssueDistrict:
        {
          label: defaulter?.citizenshipIssueDistrict,
          value: defaulter?.citizenshipIssueDistrict,
        } ?? "",
      fathersFullName: defaulter?.fathersFullName ?? "",
      grandfatherFullName: defaulter?.grandfatherFullName ?? "",
      registrationNumber: defaulter?.registrationNumber ?? "",
    },
    validationSchema: CicValidation,
    onSubmit: async (values, { resetForm }) => {
      const formattedData = {
        ...values,
        citizenshipIssueDistrict: values.citizenshipIssueDistrict.value,
        reportingBasis:
          values.reportingBasis === "DueIntrest"
            ? 1
            : values.reportingBasis === "DueInstallment"
            ? 2
            : 3,
        defaulterType: defaultersType === "Individual" ? 1 : 2,
      };

      try {
        if (id) {
          await CICServices.update(id, formattedData);
          toast.success("CIC Updated Successfully!");
        } else {
          await CICServices.create(formattedData);
          toast.success("CIC Added Successfully");
        }
        resetForm();
        navigate("/cic");
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    },
  });
  console.log("formik response", formik.values);
  return (
    <Container fluid>
      <div className="">
        <div className="page-content">
          <Breadcrumbs items={breadcrumbItems1} />
          <Row className="justify-content-center">
            <Col xs={5}>
              <Row className="mb-3">
                <Col xs={12} className="text-end">
                  <h2
                    className="cursor-pointer"
                    onClick={() => {
                      navigate("/cic");
                    }}
                  >
                    <i className="bx bx-x"></i>
                  </h2>
                </Col>
                <Col xs={12} className="text-center">
                  <h3 className="card-title mb-0">Add Defaulters</h3>
                </Col>
              </Row>
              <Card
                className="rounded-lg"
                style={{ borderRadius: "20px", backgroundColor: "#f9f9ff" }}
              >
                <CardBody className="form-steps">
                  <Form onSubmit={formik.handleSubmit}>
                    <Row>
                      <Col xs={1}>
                        <h4
                          className="cursor-pointer"
                          onClick={() => {
                            toggleArrowTab(activeArrowTab - 1);
                          }}
                        >
                          {activeArrowTab !== 4 && (
                            <i className="bx bx-left-arrow-alt"></i>
                          )}
                        </h4>
                      </Col>
                      <Col xs={10} className="text-center my-4">
                        {activeArrowTab === 4
                          ? "Select defaulter type"
                          : defaultersType === "Individual"
                          ? "Defaulter Personal Details"
                          : "Defaulter Institutional Details"}
                      </Col>
                    </Row>
                    <div className="step-arrow-nav mb-4">
                      <Nav
                        className="nav-pills custom-nav nav-justified"
                        role="tablist"
                      >
                        <NavItem
                          className={`${
                            activeArrowTab === 4 ? "bg-primary" : ""
                          }`}
                          style={{ height: "5px", width: "50%" }}
                        />
                        <NavItem
                          className={`${
                            activeArrowTab === 5 ? "bg-primary" : ""
                          }`}
                          style={{ height: "5px", width: "33.33%" }}
                        />
                        <NavItem
                          className={`${
                            activeArrowTab === 6 ? "bg-primary" : ""
                          }`}
                          style={{ height: "5px", width: "33.33%" }}
                        >
                          <NavLink id="steparrow-gen-info-tab"></NavLink>
                        </NavItem>
                      </Nav>
                    </div>

                    <TabContent activeTab={activeArrowTab}>
                      <TabPane id="steparrow-gen-info" tabId={4}>
                        <DefaultersType
                          defaultersType={defaultersType}
                          setDefaultersType={setDefaultersType}
                        />
                        <div className="d-flex align-items-start gap-3 mt-4">
                          <button
                            type="button"
                            className="btn btn-success mx-auto w-50"
                            onClick={() => {
                              toggleArrowTab(activeArrowTab + 1);
                            }}
                          >
                            Next
                          </button>
                        </div>
                      </TabPane>
                      <TabPane id="steparrow-description-info" tabId={5}>
                        {defaultersType === "Individual" ? (
                          <IndividualDefaulters formik={formik} />
                        ) : (
                          <InstutionalDefaulters formik={formik} />
                        )}
                        <div className="d-flex align-items-start gap-3 mt-4">
                          <button
                            type="submit"
                            className="btn btn-success mx-auto nexttab w-100"
                          >
                            Save
                          </button>
                        </div>
                      </TabPane>
                      <TabPane id="pills-experience" tabId={6}>
                        <div className="text-center">
                          <div className="avatar-md mt-5 mb-4 mx-auto">
                            <div className="avatar-title bg-light text-success display-4 rounded-circle">
                              <i className="ri-checkbox-circle-fill"></i>
                            </div>
                          </div>
                          <h5>
                            Thank you for submitting your creditor details
                          </h5>
                          <p className="text-muted">
                            We will analyze your creditor details and get back
                            to you ASAP
                          </p>
                          <div className="d-flex align-items-start gap-3 mt-4">
                            <button
                              type="button"
                              className="btn btn-success mx-auto nexttab w-50"
                              onClick={() => {
                                navigate("/cic");
                              }}
                            >
                              Done
                            </button>
                          </div>
                        </div>
                      </TabPane>
                    </TabContent>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </Container>
  );
};

export default AddDefaulters;
